export const filterObjectByValue = <T extends Record<string, unknown>>(
	obj: T,
	filterFn: (value: unknown) => boolean,
): Partial<T> => {
	return Object.fromEntries(
		Object.entries(obj).filter(([_, v]) => filterFn(v)),
	) as Partial<T>;
};
